import { render } from "./ModalBox.vue?vue&type=template&id=339044ee&scoped=true"
import script from "./ModalBox.vue?vue&type=script&lang=js"
export * from "./ModalBox.vue?vue&type=script&lang=js"

import "@/assets/styles/components/collections/elements/modalBox.styl?vue&type=style&index=0&id=339044ee&lang=stylus&scoped=true"

import exportComponent from "/runner/_work/cb-checkout/cb-checkout/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-339044ee"]])

export default __exports__